import type * as React from 'react';

/** 距元素边缘多少画布像素以内算「边框拖拽区」 */
export const TEXT_ELEMENT_BORDER_DRAG_PX = 10;

/** 内容区在屏幕上的最小半轴（px），避免缩放后整块被算作边框、永远无法点进编辑 */
const MIN_CONTENT_HALF_PX = 6;

/**
 * 文本元素外沿窄环为拖拽区；缩放后可视区域很小时会压缩环宽，保证中央始终有可点进编辑的区域。
 */
export function isTextElementBorderDragZone(
  e: React.MouseEvent,
  rotation = 0,
  borderPx = TEXT_ELEMENT_BORDER_DRAG_PX,
): boolean {
  const el = e.currentTarget as HTMLElement;
  const rect = el.getBoundingClientRect();
  const w = el.offsetWidth;
  const h = el.offsetHeight;
  const cx = rect.left + rect.width / 2;
  const cy = rect.top + rect.height / 2;
  const rad = (rotation * Math.PI) / 180;
  const absCos = Math.abs(Math.cos(rad));
  const absSin = Math.abs(Math.sin(rad));
  const denomW = w * absCos + h * absSin;
  const zoom = denomW > 0 ? rect.width / denomW : 1;
  const dx = e.clientX - cx;
  const dy = e.clientY - cy;
  const lx = dx * Math.cos(rad) + dy * Math.sin(rad);
  const ly = -dx * Math.sin(rad) + dy * Math.cos(rad);
  const hw = (w * zoom) / 2;
  const hh = (h * zoom) / 2;
  let bx = borderPx;
  let by = borderPx;
  if (hw - bx < MIN_CONTENT_HALF_PX) bx = Math.max(0, hw - MIN_CONTENT_HALF_PX);
  if (hh - by < MIN_CONTENT_HALF_PX) by = Math.max(0, hh - MIN_CONTENT_HALF_PX);
  return (
    lx < -hw + bx ||
    lx > hw - bx ||
    ly < -hh + by ||
    ly > hh - by
  );
}
